import React from 'react';

import Text from '@/common/components/text';
import { appConfigs } from '@/common/configs/app.config';
import { rialToToman } from '@/common/utils/money-exchange.utility';

import ShippingIcon from '~/public/assets/images/svg/truck.svg';

interface ShippingPriceProps {
  price: number;
  payer: 'shopper' | 'vendor';
}

export default function ShippingPrice({ price, payer }: ShippingPriceProps) {
  const renderShippingPrice = () => {
    switch (payer) {
      case 'shopper':
        return 'ارسال این محصول به روش پس کرایه و به عهده مشتریه.';
      case 'vendor':
        if (price !== 0) {
          return (
            <div className="flex items-center gap-0.5">
              <Text className="text-sm font-medium">هزینه ارسال این محصول</Text>
              <Text className="text-sm font-bold">
                {rialToToman(
                  price,
                  appConfigs.rialExchangeRate
                ).toLocaleString()}{' '}
                تومنه.
              </Text>
            </div>
          );
        }
        return `هزینه ارسال این محصول رایگانه.`;

      default:
        return 'هزینه ارسال نامشخص';
    }
  };

  return (
    <div className="flex flex-col gap-3 rounded-2xl bg-white px-4 py-3">
      <div className="flex items-center gap-1">
        <ShippingIcon className={'h-5 w-5 text-secondary-400'} />
        <Text className="text-sm font-semibold text-secondary-400">
          هزینه ارسال:
        </Text>
      </div>
      <Text className="text-sm font-medium text-black-400">
        {renderShippingPrice()}
      </Text>
    </div>
  );
}
